import styled from "styled-components";
import { Button, Tooltip } from 'antd';

export const DivBotaoDownloadPlanilha = styled.div`
  display: flex;
  flex-direction: row;
  align-itens: baseline;

  z-index: 999 !important;
`;

export const BotaoDownloadPlanilhas = styled(Button)`
  margin: 0 !important;
  padding: 0 !important;

  color: #1890ff !important;
`;


export const ButtonTooltip = styled(Tooltip)`
  margin: 0 0 0 1em !important;
`;